import { CourseBlock, numberedList } from "../../../Pages/CourseTarget/courseBlocks";
import { MaterialList } from "../../../layoutPages/components/MaterialList";
import { MainCards } from "../../../layoutPages/containers/MainCards";
import { openVideoList } from "../../../system/Slicer/CommonSlicer";
import { useDispatch } from "react-redux";
import { mathsImg } from "./img";

const PDF_BASE = "https://www.pkps.edu.hk/09-10%20teachplan/final/images/MS/pdf";

/** 數學科活動影片(icon01 彈窗用)*/
const mathsDisplayVideos = [
    { year: "23-24年度", url: "https://www.youtube.com/watch?v=uCryIWv4Q_s" },
    { year: "25-26年度", url: "https://www.youtube.com/watch?feature=shared&v=DOGA6fR65rQ" },
];

function MathsDisplayIconWall() {
    const dispatch = useDispatch();
    return (
        <MainCards
            height="100px"
            justifyContent="flex-start"
            data={[
                {
                    src: mathsImg.displayIcon01,
                    onClick: () =>
                        dispatch(openVideoList({ title: "探訪老人院(服務學習)影片", data: mathsDisplayVideos })),
                },
                {
                    src: mathsImg.displayIcon02,
                    onClick: () =>
                        window.open("https://www.youtube.com/watch?v=TLADAEeRj1U", "_blank", "noopener,noreferrer"),
                },
                {
                    src: mathsImg.displayIcon03,
                    onClick: () =>
                        window.open("https://www.youtube.com/watch?v=aliZIvoTojI", "_blank", "noopener,noreferrer"),
                },
                {
                    src: mathsImg.displayIcon04,
                    onClick: () =>
                        window.open("https://www.youtube.com/watch?v=k4m5ovFYeSg", "_blank", "noopener,noreferrer"),
                },
                {
                    src: mathsImg.displayIcon05,
                    onClick: () =>
                        window.open("https://www.youtube.com/watch?v=PRffztOrwZU", "_blank", "noopener,noreferrer"),
                },
                {
                    src: mathsImg.displayIcon06,
                    onClick: () => window.open("https://youtu.be/46jEhD0RiCY", "_blank", "noopener,noreferrer"),
                },
            ]}
        />
    );
}

/** 數學科 > 學生成果展示 */
export const mathsDisplayBlocks: CourseBlock[] = [
    {
        type: "custom",
        node: <MathsDisplayIconWall />,
    },
    {
        type: "paragraph",
        title: "校本特色課業設計分享:",
        data: [
            <MaterialList
                data={[
                    {
                        name: "學生成果展示",
                        src: "http://www.pkps.edu.hk/20years/subject/maths.html",
                    },
                ]}
            />,
            numberedList([
                "生活課業，讓學生經歷不一樣的數學學習歷程，藉此提升學生學習數學的興趣與參與性，培養學生的協作、創作與溝通等能力，擴闊思考。",
                "為引發學生對課堂以外知識的好奇心，熱愛數學並享受自學的樂趣，四至六年級設置多元課業―課後延伸。",
                "數學科學習歷程檔案: 是教學及學習的結合，以情境化、脈絡化的學習模式，為學生提供不同的學習經歷，推動學生積極地進行自主學習和自我反思。",
                "(四)	數學悅讀計畫 : 閱讀是重要的自學策略，亦是作為終身學習的一項必需具備的能力，而透過閱讀，學生能從中認識世界，學習課本以外的知識。校本的數學「悅」讀計劃(小二至小五)，提升學生的閱讀能力的同時，亦培養他們的數學素養。",
            ]),
        ],
    },
    {
        type: "paragraph",
        title: "追求卓越，積極參與校外數學比賽",
        data: [
            <MaterialList
                data={[
                    { name: "25-26年度校外數學比賽得獎名單", src: `https://www.pkps.edu.hk/img/teachplan/maths/display/2526.pdf` },
                    { name: "24-25年度校外數學比賽得獎名單", src: `${PDF_BASE}/2425.pdf` },
                    { name: "23-24年度校外數學比賽得獎名單", src: `${PDF_BASE}/2023-2024.pdf` },
                ]}
            />,
        ],
    },
    {
        type: "photoRow",
        text: "2026年 本校同學積極參與華夏杯全國數學奧林匹克邀請賽(華南賽區)，以下為獲獎同學們，成績優異。",
        images: ["http://www.pkps.edu.hk/img/teachplan/maths/display/2526-dp01.jpg"],
        height: "450px",
    },
    {
        type: "photoRow",
        text: "2026年東區數學比賽(小五﹑小六)，獲優異獎同學們。",
        images: [
            "http://www.pkps.edu.hk/img/teachplan/maths/display/2526-dp02.jpg",
            "http://www.pkps.edu.hk/img/teachplan/maths/display/2526-dp03.jpg",
        ],
        height: "450px",
    },
    {
        type: "photoRow",
        text: "2026年度舉辦AR悅讀「方」校內班際比賽，獲獎同學拍照留念。",
        images: ["http://www.pkps.edu.hk/img/teachplan/maths/display/2526-dp04.jpg"],
        height: "450px",
    },
    {
        type: "photoRow",
        text: "2025年 本校同學積極參與華夏杯全國數學奧林匹克邀請賽(華南賽區)，以下為獲獎同學們，成績優異。",
        images: [mathsImg.display2a, mathsImg.display2c, mathsImg.display2b],
        height: "450px",
    },
    {
        type: "photoRow",
        text: "24-25年度第十二屆Rummikub小學挑戰賽獲團體第2名。",
        images: [mathsImg.display3a, mathsImg.display3b],
        height: "450px",
    },
    {
        type: "photoRow",
        text: "2024年 本校同學積極參與華夏杯全國數學奧林匹克邀請賽(華南賽區)，以下為獲獎同學們，成績優異。",
        images: [mathsImg.display0a, mathsImg.display0b],
        height: "400px",
    },
    {
        type: "photoRow",
        text: "2019年榮獲「第十五屆香港校際盃珠心算比賽」高級組團體賽亞軍，低級組團體賽冠軍殊榮。",
        images: [mathsImg.displayLegacy04, mathsImg.displayLegacy05, mathsImg.displayLegacy08],
        height: "400px",
    },

    {
        type: "mainCard",
        src: mathsImg.displayLegacy16,
        noImgPopup: true,
    },
];
